export default __webpack_public_path__ + "static/media/ickasso.232e5526.jpg";